export default "__VITE_ASSET__D2tz3cnk__"